import React, { useEffect } from 'react';
import { InformationCircleIcon } from '@heroicons/react/solid';
import ReactTooltip from 'react-tooltip';
import useSWR from 'swr';
import Api from '../../../api/Api';
import { useDataVisualisation } from '../../../hooks/useDataVisualisation';
import ahoy from 'ahoy.js';
import classNames from 'classnames';
import { useModal } from '../../../hooks/useModal';
import LoadingBox from '../../utils/LoadingBoxSimple';

ahoy.configure({
  visitsUrl: '/steps/visits',
  eventsUrl: '/steps/events',
});

const fetcher = (url) => Api.get(url).then((res) => res.data);

const BoxComp1 = ({ url, print_mode = false, data, isEDM = false }) => {
  const { isQuickCheckModalOpened } = useModal();

  const responseSWR = !isEDM && useSWR(url, fetcher);

  const { urlMap, setUrlMap, setTabIndexSelected } = useDataVisualisation();

  const _data = isEDM ? data : responseSWR?.data;

  if (responseSWR?.error) {
    return <div>Loading failed...</div>;
  }

  if (!_data) {
    return (
      <div>
        <LoadingBox printMode={print_mode} boxSize={'large'} />
      </div>
    );
  }

  const {
    // axe_analyse,
    bas_de_box,
    carto_link,
    information,
    metric_commune,
    metric_epci,
    // order_id,
    // source,
    // sous_axe,
    // tableau_id,
    titre_box,
    // type_box,
  } = _data;

  const style = {
    height: `${print_mode ? '110px' : '120px'}`,
  };

  return (
    <div
      style={style}
      className={classNames(
        'flex flex-col py-3 px-4 bg-white shadow rounded-lg overflow-hidden sm:p-2 sm:px-3 justify-between border-gray-200 border-2',
        {
          'bg-blue-600': carto_link === urlMap,
          'cursor-pointer hover:bg-blue-100':
            !!carto_link && !isQuickCheckModalOpened,
          'inline-block mx-1 py-1': print_mode,
        }
      )}
      onClick={(event) => {
        event.preventDefault();
        if (!isQuickCheckModalOpened) {
          ahoy.track('$click', { titre_box: titre_box, type_box: 'BoxComp1' });
          carto_link && setUrlMap(carto_link);
          carto_link && setTabIndexSelected(0);
        }
        return;
      }}
    >
      <div className="flex flex-row justify-between">
        <dt className="text-xs  font-medium text-orange-600 leading-tight">
          {titre_box}
        </dt>
        {!print_mode && (
          <dt
            className="text-base font-medium text-gray-600"
            data-for="tooltip-global"
            data-tip={information}
            onMouseEnter={() => {
              ReactTooltip.rebuild();
            }}
          >
            <InformationCircleIcon className={'w-5'} />
          </dt>
        )}
      </div>
      <div className={'flex flex-row justify-between'}>
        <div className="">
          <dd
            className={`${
              print_mode ? 'text-base' : 'text-lg'
            } font-semibold text-gray-900`}
          >
            {metric_commune}
          </dd>
          <dd className="text-xs font-semibold text-gray-800">Commune</dd>
        </div>
        <div>
          <dd
            className={`${
              print_mode ? 'text-base' : 'text-lg'
            } font-semibold text-gray-900`}
          >
            {metric_epci}
          </dd>
          <dd className="text-xs font-semibold text-gray-800">EPCI</dd>
        </div>
      </div>
      <dt
        className={`${
          print_mode ? 'text-sm' : 'text-xs'
        } font-medium text-gray-500`}
      >
        {bas_de_box}
      </dt>
    </div>
  );
};

export default BoxComp1;
